import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { PosPage } from "../pos/pos";
import { PaymentPage } from "../payment/payment";
import { PaymentConfirmationPage } from "../payment-confirmation/payment-confirmation";

/**
 * Generated class for the PosTabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-pos-tabs',
    templateUrl: 'pos-tabs.html',
})
export class PosTabsPage {

    tab1Root = PosPage;
    tab2Root = PaymentPage;
    tab3Root = PaymentConfirmationPage;

    tabsData = {
        sellItems: [],
        paymentDetails : {},
        tab1Enabled: true,
        tab2Enabled: false,
        tab3Enabled: false,
    };

    constructor(public navCtrl: NavController, public navParams: NavParams) {
        //(ionSelect)="load()"
    }

    ionViewDidLoad() {
        //console.log('ionViewDidLoad PosTabsPage');
    }

    ionViewWillLeave() {
        //
    }

}



// WEBPACK FOOTER //
// ./src/pages/pos-tabs/pos-tabs.ts